import {create} from 'zustand';

/**
 * Global open/close state for the CMD+K spotlight search overlay.
 * Kept in a dedicated store so any component can open the spotlight without
 * prop-drilling through the route tree.
 */
const useSpotlightStore = create((set) => ({
    open: false,
    openSpotlight:   () => set({open: true}),
    closeSpotlight:  () => set({open: false}),
    toggleSpotlight: () => set((s) => ({open: !s.open})),

    /** 'hybrid' = AI-assisted (vector + keyword); 'keyword' = exact keyword only */
    searchMode: 'hybrid',
    toggleSearchMode: () => set((s) => ({searchMode: s.searchMode === 'hybrid' ? 'keyword' : 'hybrid'})),
}));

export default useSpotlightStore;
